<template>
  <keep-alive>
    <router-view />
  </keep-alive>
</template>

<script>
export default {
  name: "MetadataRulesHome",
  data() {
    return {
    }
  },
  created() { }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/MetadataRules/MetadataRulesHome.vue